import { useParams } from "react-router-dom";
import { i18n } from "./locale";

export const useLocale = () => {
  const params = useParams();
  return i18n[params.lang ?? "es"] || i18n.en;
};
